<template>
  <v-card class="mb-4">
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 md4>
          <DateDialog
            :label="$t('attrs.startDate')"
            :defaultDate="startDate"
            @onSelectDate="val => startDate = val"></DateDialog>
        </v-flex>

        <v-flex xs12 md4>
          <DateDialog
            :label="$t('attrs.endDate')"
            :defaultDate="endDate"
            @onSelectDate="val => endDate = val"></DateDialog>
        </v-flex>

        <v-flex xs12 md4>
          <v-text-field v-model="email"
                        :label="$t('attrs.email')"
                        append-icon="search"
                        @click:append="fetch"
                        @keyup.enter.native="fetch"
                        clearable
                        ></v-text-field>
        </v-flex>

        <v-btn elevation="2" color="primary" outline @click="resetFilters">{{ $t('reset') }}</v-btn>
        <v-btn elevation="2" color="primary" @click="fetch" :disabled="false">{{ $t('search') }}</v-btn>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  name: "InvoiceFilterComp",

  data () {
    return {
      email: '',
      startDate: '',
      endDate: '',
      loading: false
    }
  },

  props: {
  },

  components: {
  },

  computed: {
  },

  methods: {

    async fetch () {
      this.loading = true

      this.$emit('fetch', {
        email: this.email,
        startDate: this.startDate,
        endDate: this.endDate
      }, true)

      this.loading = false
    },

    resetFilters () {
      this.email = ''
      this.setup()
      this.fetch()
    },

    setup () {
      this.startDate = moment().startOf('month').format('YYYY-MM-DD')
      this.endDate = moment().endOf('month').format('YYYY-MM-DD')
    }
  },

  watch: {
  },

  mounted () {
    this.setup()
    this.fetch()
  }
}
</script>